import { render, staticRenderFns } from "./hd.vue?vue&type=template&id=68f84b71&scoped=true"
import script from "./hd.vue?vue&type=script&lang=js"
export * from "./hd.vue?vue&type=script&lang=js"
import style0 from "./hd.vue?vue&type=style&index=0&id=68f84b71&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68f84b71",
  null
  
)

export default component.exports